/* VIVID CRO: stop placeholder anchors (href="#") from bouncing the page to the top when
     tapped before the deferred theme JS binds. Capturing phase, no stopPropagation so the
     real click handlers still fire. */
  (function(){
    document.addEventListener('click', function(e){
      var a = e.target && e.target.closest ? e.target.closest('a[href="#"]') : null;
      if (a) { e.preventDefault(); }
    }, true);
  })();
  /* VIVID CRO v2: flow-state controller — stepper, step classes, sticky bar states.
     States: default (configure) → vq-calc-done (totals visible) → vq-step2 (artwork step). */
  (function(){
    var MOB = function(){ return window.matchMedia('(max-width:749px)').matches; };
    function injectStepper(){
      if(!MOB() || document.querySelector('.vq-stepper')) return;
      /* anchor at top level so the stepper survives step changes (the form hides on step 2).
         Theme renders duplicate desktop/mobile instances — use the VISIBLE one. */
      var host = null, wfs = document.querySelectorAll('.wraper-form');
      for(var wi=0;wi<wfs.length;wi++){ if(wfs[wi].offsetParent!==null){ host=wfs[wi]; break; } }
      if(!host){
        var cands = ['.product-variants', '.design__block__form', '#total-elementor'];
        for(var i=0;i<cands.length && !host;i++){
          var els = document.querySelectorAll(cands[i]);
          for(var j=0;j<els.length;j++){ if(els[j].offsetParent!==null || cands[i]==='#total-elementor'){ host=els[j]; break; } }
        }
      }
      if(!host) return;
      var s = document.createElement('div');
      s.className='vq-stepper';
      s.innerHTML = '<div class="vq-step" data-s="1"><b>1</b>Configure</div><div class="vq-step" data-s="2"><b>2</b>Artwork</div><div class="vq-step" data-s="3"><b>3</b>Checkout</div>';
      s.addEventListener('click', function(e){
        var st = e.target.closest('.vq-step'); if(!st) return;
        if(st.getAttribute('data-s')==='1' && document.body.classList.contains('vq-step2')){
          var back=document.querySelector('.price-details'); if(back) back.click();
        }
      });
      host.parentNode.insertBefore(s, host);
    }
    function injectStep2Extras(){
      if(!MOB() || document.querySelector('.vq-trust')) return;
      var wrap = document.querySelector('.cart-price-wrapper');
      if(!wrap) return;
      var t = document.createElement('div');
      t.className='vq-trust';
      t.innerHTML = '<div>Printed in Australia</div><div>Digital proof before printing</div><div>Dispatched from Melbourne</div>';
      wrap.insertBefore(t, wrap.firstChild);
      var n = document.createElement('div');
      n.className='vq-next';
      n.innerHTML = '<div class="vq-next-t">What happens next</div><ol><li>Place order</li><li>Receive proof</li><li>Approve artwork</li><li>We print</li><li>Dispatch in 24hrs</li></ol>';
      wrap.appendChild(n);
    }
    function sticky(label, amountText, btnText){
      var bar=document.getElementById('vivid-sticky-atc'); if(!bar) return;
      var lbl=bar.querySelector('.vivid-sticky-atc__label'); if(lbl)lbl.textContent=label;
      if(amountText!==null){ var p=document.getElementById('vivid-sticky-price'); if(p)p.textContent=amountText; }
      var b=document.getElementById('vivid-sticky-buy'); if(b)b.textContent=btnText;
    }
    function injectExactMatch(){
      if(!MOB()) return;
      function visOne(sel){ var es=document.querySelectorAll(sel); for(var k=0;k<es.length;k++){ if(es[k].offsetParent!==null) return es[k]; } return es[0]||null; }
      /* form card must sit ABOVE the quote card (mockup panel 1) */
      var w = visOne('.wraper-form'), t = document.getElementById('total-elementor');
      if(w && t && !w.contains(t) && !t.contains(w) && (w.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING)){
        t.parentNode.insertBefore(w, t);
      }
      /* artwork cards in mockup order: Later (default) first — cards sit in separate grid columns */
      document.querySelectorAll('[id="upload--instructions"]').forEach(function(later){
        var latCol = later.closest('.col-md-6') || later;
        var grp = latCol.parentNode; if(!grp) return;
        var nowCol = null;
        for(var c=0;c<grp.children.length;c++){
          var ch = grp.children[c];
          if(ch !== latCol && (ch.querySelector && ch.querySelector('.option-content-wrapper:not([id="upload--instructions"])') || (ch.classList && ch.classList.contains('option-content-wrapper') && ch.id!=='upload--instructions'))){ nowCol = ch; break; }
        }
        if(nowCol && nowCol !== latCol) grp.insertBefore(latCol, nowCol);
      });
      /* "PRODUCT DETAILS" seclabel above the variant selects */
      var pv = null, pvs = document.querySelectorAll('.product-variants');
      for(var i=0;i<pvs.length;i++){ if(pvs[i].offsetParent!==null){ pv=pvs[i]; break; } }
      if(pv && !pv.parentNode.querySelector('.vq-pd-label')){
        var l=document.createElement('div'); l.className='vq-pd-label'; l.textContent='Product details';
        pv.parentNode.insertBefore(l, pv);
      }
      /* "HOW WOULD YOU LIKE TO PROCEED?" above the artwork cards */
      var firstOpt = document.querySelector('.optional-workflow-wrapper .option-content-wrapper');
      if(firstOpt && !document.querySelector('.vq-step2-label')){
        var s2=document.createElement('div'); s2.className='vq-step2-label'; s2.innerHTML='Choose your artwork method<span class="vq-step2-sub">Select one option below.</span>';
        firstOpt.parentNode.insertBefore(s2, firstOpt);
      }
      /* Design assistance proxy card (mockup card 3) — proxies the hidden step-1 option + silent recalc */
      var hiddenAssist = document.querySelector('#design_assist a');
      if(hiddenAssist && firstOpt && !document.querySelector('.vq-assist-card')){
        var chargeEl = document.getElementById('design_charges_dpo');
        var charge = chargeEl ? ('+$' + chargeEl.textContent.trim()) : '+$99';
        var card=document.createElement('div'); card.className='vq-assist-card';
        card.innerHTML='<div class="vq-dot" style="width:20px;height:20px;border-radius:50%;border:2px solid #c8cdd4;flex:0 0 auto;margin-top:1px;"></div><div><b>Design assistance</b><p>Our designers create the artwork from your logo &amp; brief.</p></div><div class="vq-price">'+charge+'</div>';
        /* place after the LAST card column so it reads Later → Now → Assist */
        var lastCol = firstOpt.closest('.col-md-6') || firstOpt;
        var row = lastCol.parentNode;
        var cols = []; for(var rc=0;rc<row.children.length;rc++){ var rch=row.children[rc]; if(rch.querySelector && (rch.querySelector('.option-content-wrapper') || (rch.classList&&rch.classList.contains('option-content-wrapper')))) cols.push(rch); }
        var anchor = cols.length ? cols[cols.length-1] : lastCol;
        anchor.parentNode.insertBefore(card, anchor.nextSibling);
        card.addEventListener('click', function(){
          if(window.__vqSetArt) window.__vqSetArt('assist');
          var a=document.querySelector('#design_assist a'); if(a) a.click();
          window.__vqSilentCalc=true;
          var c=document.querySelector('.calculate-button'); if(c) c.click();
        });
      }
      /* "Generate professional designs instantly" — AI Design Studio as a 4th artwork method */
      var aiTrig = document.getElementById('designbtn') || document.querySelector('[data-pacdora-ui="design-btn"], #custom_design_now_btn');
      if(aiTrig && firstOpt && !document.querySelector('.vq-ai-card')){
        var aiCard=document.createElement('div'); aiCard.className='vq-assist-card vq-ai-card';
        aiCard.innerHTML='<div class="vq-dot" style="width:20px;height:20px;border-radius:50%;border:2px solid #c8cdd4;flex:0 0 auto;margin-top:1px;"></div><div><b>Create designs with AI <span class="vq-ai-star">★</span></b><p>Generate professional concepts in minutes.</p></div><div class="vq-price">$0</div>';
        var prevAssist = document.querySelector('.vq-assist-card:not(.vq-ai-card)');
        if(prevAssist){ prevAssist.parentNode.insertBefore(aiCard, prevAssist.nextSibling); }
        aiCard.addEventListener('click', function(){
          if(window.__vqSetArt) window.__vqSetArt('ai');
          var t = document.getElementById('designbtn') || document.querySelector('[data-pacdora-ui="design-btn"], #custom_design_now_btn');
          if(t) t.click();
        });
      }
      /* "What you'll receive" ticks in the fold (derived from the kit option text) */
      function renderReceive(){
        var fold=document.querySelector('.vivid-fold'); if(!fold) return;
        var sel=document.querySelector('.product-variants select'); if(!sel) return;
        var opt=sel.options[sel.selectedIndex]; var txt=opt?(opt.text||''):'';
        var old=fold.querySelector('.vq-receive'); 
        if(txt.indexOf('+')<0){ if(old) old.remove(); return; }
        var parts=txt.split('+').map(function(s){return s.trim();}).filter(Boolean);
        var html='<div class="vq-receive-t">What you\'ll receive</div>'+parts.map(function(p){return '<span><i class="vq-tick">✓</i>'+p+'</span>';}).join('')+'<span class="vq-chip-au"><i class="vq-tick">✓</i>Printed in Australia</span>';
        if(old){ old.innerHTML=html; return; }
        var el=document.createElement('div'); el.className='vq-receive'; el.innerHTML=html;
        var badges=fold.querySelector('.vivid-fold__badges');
        if(badges) badges.parentNode.insertBefore(el, badges.nextSibling); else fold.appendChild(el);
      }
      renderReceive();
      document.addEventListener('change', function(ev){ if(ev.target && ev.target.matches && ev.target.matches('.product-variants select')) setTimeout(renderReceive, 100); }, true);
      /* TOTAL line inside the trust card */
      var trust = document.querySelector('.vq-trust');
      if(trust && !trust.querySelector('.vq-trust-total')){
        var t=document.createElement('div'); t.className='vq-trust-total';
        t.innerHTML='<span>TOTAL (INCL GST)</span><b><em id="vq-trust-price" style="font-style:normal;"></em><i>inc GST</i></b>';
        trust.insertBefore(t, trust.firstChild);
      }
      var tp=document.getElementById('tprice'), vt=document.getElementById('vq-trust-price');
      if(tp && vt){
        var syncT=function(){ var v=(tp.textContent||'').trim(); if(v) vt.textContent=v; };
        syncT();
        try{ new MutationObserver(syncT).observe(tp,{childList:true,subtree:true,characterData:true}); }catch(e){}
      }
    }
    /* INSTANT PRICING: any select change triggers a silent calculate — the totals
       card simply appears/updates. No "See my total" press needed (it remains as
       a fallback until the first change). */
    function vqSilentCalc(y0){
      /* 2026-08-19 jump fix, two parts:
         1. y is captured AT THE TRIGGERING EVENT (passed in by the listeners below),
            not after the 150/300ms timeout — capturing late meant the legacy calc
            animation had already moved the page, so the pin held the user at a
            mid-animation position ~hundreds of px from where they actually were.
         2. The pin releases the moment the user scrolls themselves (touch/wheel/key).
            It used to fight every real gesture for 2.6s, snapping the page back
            every 120ms — the "page keeps jumping" complaint. Animation-stopping
            keeps running for the full window; only the pin is released. */
      var y = (typeof y0 === 'number') ? y0 : window.scrollY;
      var userMoved = false;
      var mark = function(){ userMoved = true; };
      window.addEventListener('touchstart', mark, {passive:true});
      window.addEventListener('wheel', mark, {passive:true});
      window.addEventListener('keydown', mark, {passive:true});
      window.__vqSilentCalc=true;
      var c=document.querySelector('.calculate-button'); if(c) c.click();
      var until = Date.now() + 2600;
      var iv = setInterval(function(){
        if(window.jQuery){ try{ jQuery('html, body').stop(true); }catch(e){} }
        if(!userMoved && Math.abs(window.scrollY - y) > 40) window.scrollTo(0, y);
        if(Date.now() > until){
          clearInterval(iv);
          window.removeEventListener('touchstart', mark);
          window.removeEventListener('wheel', mark);
          window.removeEventListener('keydown', mark);
        }
      }, 120);
    }
    /* 27 Sep 2026 (Report 82): the visible .vvbc buy panel owns pricing. Clicking the legacy
       .calculate-button from here swapped the whole panel for the 500px #total_loader for ~2s,
       which is the mobile PDP layout shift (lab: CLS 0.84-1.33 per size+qty tap). Skip it when
       the panel is visible; products whose .vvbc is hidden (native calculators) are unchanged. */
    /* 27 Sep 2026 (Report 83, owner option b): Class A / DPO-priced products keep the LIVE behaviour
       (legacy silent-calc + its sticky figure) until the panel-total vs DPO option-charge gap is fixed —
       the .vvbc total understates the cart there (life-size-cutouts $188.10 vs $192.06). Handles = Report 82 class A. */
    var VQ_DPO_PRICED=['fence-mesh-banners','graphics-only-curved-stretch-fabric-walls','life-size-cutouts','real-estate-directional-signs','real-estate-pointer-signs','replacement-graphics-led-pop-up-counter','replacement-graphics-only-exhibition-tv-stand','replacement-graphics-only-pop-up-counters','replacement-graphics-only-pump-up-counters'];
    function vqDpoPriced(){ if(window.__vqDpoPriced!=null) return window.__vqDpoPriced;
      var h=''; try{ var d=document.getElementById('vvbc-data'); if(d) h=JSON.parse(d.textContent).handle||''; }catch(e){}
      if(!h){ var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(m) h=decodeURIComponent(m[1]); }
      return (window.__vqDpoPriced = VQ_DPO_PRICED.indexOf(h)>-1); }
    function vqPanelOwnsPricing(){ if(vqDpoPriced()) return false; var v=document.querySelector('.vvbc'); return !!(v && v.offsetParent!==null); }
    document.addEventListener('change', function(e){
      if(!MOB() || vqPanelOwnsPricing()) return;
      if(e.target && (e.target.matches('.product-variants select') || e.target.matches('#productSelect') || e.target.matches('.wraper-form select'))){
        var y0 = window.scrollY;
        setTimeout(function(){ vqSilentCalc(y0); }, 150);
      }
    }, true);
    /* custom quantity dropdown picks */
    document.addEventListener('click', function(e){
      if(!MOB() || vqPanelOwnsPricing()) return;
      if(e.target && e.target.closest && e.target.closest('#PDPQty li, #PDPQty .select-options *, .qty-wrapper .select-options *')){
        var y0 = window.scrollY;
        setTimeout(function(){ vqSilentCalc(y0); }, 300);
      }
    }, true);
    setTimeout(function(){ injectExactMatch(); injectStepper(); injectStep2Extras(); }, 1200);
    setTimeout(function(){ injectExactMatch(); injectStepper(); injectStep2Extras(); }, 4000);
    /* initial sticky labels (estimate state) */
    setTimeout(function(){ if(!window.__vqCalculated){ sticky('Total estimate', null, 'See total'); } }, 1300);
    document.addEventListener('click', function(e){
      var el = e.target && e.target.closest ? e.target : null;
      if(!el) return;
      if(e.target.closest('.quote_btn .confirm_order')){
        document.body.classList.add('vq-step2');
        setTimeout(function(){ sticky('Ready to order', null, 'Buy Now'); }, 600);
        return;
      }
      if(e.target.closest('.price-details')){
        document.body.classList.remove('vq-step2');
        setTimeout(function(){ sticky('Total estimate', null, 'Continue'); }, 600);
        return;
      }
      if(e.target.closest('.details-back, .request_quote')){
        window.__vqCalculated=false;
        document.body.classList.remove('vq-calc-done');
        document.body.classList.remove('vq-step2');
        var bar=document.getElementById('vivid-sticky-atc');
        sticky('Total estimate', bar?bar.getAttribute('data-from-price'):null, 'See total');
        return;
      }
    }, true);
  })();
  /* VIVID TURNAROUND BY QUANTITY (24 Oct 2026, PREVIEW only — docs/director/growth/turnaround-by-quantity-2026-10-24.md).
     One source of truth: the AI console engine, GET https://ai.vividads.com.au/api/turnaround. Until that answers
     (or if it fails) the STATIC copy below is used — the owner-approved defaults, identical to the console seed.
     Replaces the old PRICE bands (<$1000 = 24h, <=$2000 = 48h ...) with QUANTITY tiers, Melbourne time, working days
     that skip weekends + VIC public holidays. Original Vivid wording. */
  (function(){
    if(window.vvTurnaround) return;
    var S = { cutoffHour: 15, provisionalDays: 4,
      tiers: [{min:1,max:15,days:1},{min:16,max:40,days:2},{min:41,max:100,days:3},{min:101,max:200,days:4},{min:201,max:null,days:null}],
      holidays: ['2026-11-03','2026-12-25','2026-12-28','2027-01-01','2027-01-26','2027-03-08','2027-03-26','2027-03-29','2027-06-14','2027-11-02','2027-12-27','2027-12-28'],
      smallPrint: 'Counted from proof approval by 3pm Melbourne time. Working days are Monday to Friday, not including Victorian public holidays. Delivery time is added after dispatch.' };
    var cfg = S;
    /* FIX 24 Oct (L2): no flash of the old "3:00pm AEST" cut-off row (corflute): hidden until deadline() rewrites it */
    try{ if(!document.getElementById('vvta-pre')){ var pre=document.createElement('style'); pre.id='vvta-pre'; pre.textContent='.vvbc-deadline:not(.vvta-dl),.vvbc-drow[data-del="0"]:not(.vvta-row0) .vvbc-dt,.vvbc-drow[data-del="0"]:not(.vvta-row0) .vvbc-dr,.vvbc-drow[data-del="0"]:not(.vvta-row0) .vvbc-ds{visibility:hidden}'; (document.head||document.documentElement).appendChild(pre); } }catch(e){}
    var DOW=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function mel(at){ var p={}; new Intl.DateTimeFormat('en-CA',{timeZone:'Australia/Melbourne',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(at).forEach(function(x){p[x.type]=x.value;}); return { ymd:p.year+'-'+p.month+'-'+p.day, hour:Number(p.hour)%24, min:Number(p.minute) }; }
    function addD(y,n){ var d=new Date(y+'T00:00:00Z'); d.setUTCDate(d.getUTCDate()+n); return d.toISOString().slice(0,10); }
    function work(y){ var w=new Date(y+'T12:00:00Z').getUTCDay(); return w!==0 && w!==6 && cfg.holidays.indexOf(y)<0; }
    function nextWork(y){ var i=0; while(!work(y) && i++<60) y=addD(y,1); return y; }
    function addWork(y,n){ y=nextWork(y); while(n>0){ y=addD(y,1); if(work(y)) n--; } return y; }
    function fmt(y){ var d=new Date(y+'T12:00:00Z'); return DOW[d.getUTCDay()]+' '+d.getUTCDate()+' '+MON[d.getUTCMonth()]; }
    function wd(n){ return n===1 ? '1 working day' : n+' working days'; }
    function range(t){ return t.max===null ? t.min+'+' : t.min+'–'+t.max; }
    function cut(){ var h=cfg.cutoffHour; return (h%12||12)+(h<12?'am':'pm')+' Melbourne time'; }
    /* FIX 24 Oct (M1): the product's own lead time is a FLOOR everywhere (row, cut-off, "By quantity" panel, sticky):
       read straight from window.__vqTeaserTier so the panel never shows a faster tier than the product page's row. */
    var TT_DAYS={'24 hours':1,'48 hours':2,'72 hours':3,'96 hours':4,'7 days':7};
    function floorDays(){ var t=window.__vqTeaserTier, f=TT_DAYS.hasOwnProperty(t)?TT_DAYS[t]:0; f=Math.max(f, window.__vvTaFloor||0); return f>1?f:0; }
    function tierFor(q){ q=Math.max(1,Math.floor(Number(q)||1)); for(var i=0;i<cfg.tiers.length;i++){ var t=cfg.tiers[i]; if(q>=t.min && (t.max===null||q<=t.max)) return t; } return cfg.tiers[cfg.tiers.length-1]; }
    /* minDays: the product's own floor (e.g. SEG lightboxes 72h) — never promise faster than the product page did */
    function forQty(q, minDays){
      var now=mel(new Date()), t=tierFor(q), prov=(t.days===null);
      var days=Math.max(prov?cfg.provisionalDays:t.days, minDays||0);
      var from=(work(now.ymd) && now.hour<cfg.cutoffHour) ? now.ymd : nextWork(addD(now.ymd,1));
      var ready=addWork(from,days);
      var mins=(from===now.ymd) ? Math.max(0,(cfg.cutoffHour-now.hour)*60-now.min) : null;
      return { qty:Math.max(1,Math.floor(Number(q)||1)), days:days, provisional:prov, approveBy:fmt(from), ready:fmt(ready), mins:mins, tier:t };
    }
    function currentQty(){ /* corflute calculator and the exact-quantity box first, then the chosen tile */
      try{ var c=document.querySelector('.vcorf input[data-qty]'); if(c&&c.offsetParent){ var n=parseInt(c.value,10); if(n>0) return n; }
        var e=document.querySelector('.vvbc-exact input'); if(e&&e.value){ var n2=parseInt(e.value,10); if(n2>0) return n2; } }catch(err){}
      var q=window.__vvbcQty; if(!q){ var i=document.querySelector('input[name="quantity"]'); q=i&&parseInt(i.value,10); } return q||1; }
    /* 24 Oct 10:43 redesign (owner: "the table looks fully off"): no standalone table. The dispatch promise lives where
       the buy box already talks about timing (Helloprint-style "Estimated ... date" rows, Vistaprint-style date by the
       price): the Delivery row shows the live date for the chosen quantity, the cut-off line carries the countdown, and
       a small "Turnaround by quantity" toggle on the section label opens the tiers. Zero extra height when closed. */
    var CSS='.vvta-lbl{display:flex;align-items:baseline;justify-content:space-between;gap:8px;flex-wrap:wrap}'+
      '.vvta-tog{background:none;border:0;padding:0;margin:0;font:inherit;font-size:13px;font-weight:600;color:#d6202b;cursor:pointer;white-space:nowrap}'+
      '.vvta-tog:hover,.vvta-tog:focus-visible{text-decoration:underline}.vvta-tog:focus-visible{outline:2px solid #d6202b;outline-offset:2px;border-radius:2px}'+
      '.vvta-tog i{display:inline-block;font-style:normal;margin-left:4px;transition:transform .15s}.vvta-tog[aria-expanded="true"] i{transform:rotate(180deg)}'+
      '.vvta-pan{background:#f7f7f7;border-radius:5px;padding:10px 14px;margin:0 0 10px;font-size:13px;line-height:1.45;color:#6b6b6b}'+
      '.vvta-pan[hidden]{display:none}.vvta-row{display:flex;justify-content:space-between;gap:12px;padding:3px 0}'+
      '.vvta-row span:first-child{white-space:nowrap}.vvta-row span:last-child{text-align:right}.vvta-row.on{color:#191919;font-weight:600}.vvta-row.on span:first-child:before{content:"";display:inline-block;width:6px;height:6px;border-radius:50%;background:#ff454e;margin:0 6px 1px -12px;vertical-align:middle}'+
      '.vvta-sp{display:block;font-size:11.5px;margin-top:6px;line-height:1.4}'+
      '.vvbc-deadline.vvta-dl{display:block;line-height:1.5;text-align:left}.vvbc-deadline.vvta-dl b{display:inline;font-weight:700}.vvbc-deadline.vvta-dl .vvbc-dl-count{display:inline;white-space:nowrap}'+
      '.vvbc-drows .vvbc-drow.vvta-row0{padding-right:16px}.vvbc-drows .vvbc-drow.vvta-row0 .vvbc-dr{position:static;transform:none;top:auto;right:auto;font-size:12px;color:#6b6b6b;text-align:left}'+
      '.vvta-bq{display:none}@media (max-width:749px){.vvta-long{display:none}.vvta-bq{display:inline}}'+
      /* FIX2 24 Oct: courier delivery times under the quantity tiers (inside the closed-by-default panel) */
      '.vvta-dh{border-top:1px solid #e3e3e3;margin-top:8px;padding-top:8px;color:#191919;font-weight:600}.vvta-dh small{display:block;font-weight:400;font-size:11.5px;color:#6b6b6b}'+
      '.vvta-dg .vvta-row span:first-child{white-space:normal}.vvta-dg .vvta-row span:last-child{white-space:nowrap}';
    function css(){ if(document.getElementById('vvta-css')) return; var st=document.createElement('style'); st.id='vvta-css'; st.textContent=CSS; document.head.appendChild(st); }
    function setText(el,t){ if(el && el.textContent!==t) el.textContent=t; }
    var TIP='This is the day your order is ready to dispatch. We count working days (Monday to Friday, not Victorian public holidays) from when you approve your proof by 3pm Melbourne time. Approve after 3pm and we count from the next working day. Delivery time is added after dispatch. Most deliveries then take 1–3 business days (longer to WA, NT and remote areas).';
    function items(n){ return n+' item'+(n===1?'':'s'); }
    /* FIX2 24 Oct (owner-approved): courier estimate after dispatch, business days. Plain estimate, not a promise. */
    var DELIV=[['Melbourne','1 day'],['Sydney, Canberra, Adelaide','1–2 days'],['Brisbane','2–3 days'],['Perth, Hobart','4–5 days'],['Darwin','6–7 days'],['Regional areas','add 1–3 days']];
    function table(){ /* name kept: the date-block code calls vvTurnaround.table() */
      var old=document.querySelector('.vv-ta-table'); if(old) old.remove();
      var row=document.querySelector('.vvbc-drow[data-del="0"]'); if(!row) return;
      css();
      var r=forQty(currentQty(), floorDays());
      /* 1. Delivery row = the date for the chosen quantity (the row the buy box already had for this) */
      setText(row.querySelector('.vvbc-dt'), r.provisional ? 'Ready to dispatch: we’ll confirm' : 'Ready to dispatch '+r.ready);
      /* 24 Oct 17:47 (owner): "Calculated at checkout" beside the date read as if the DATE was calculated at checkout.
         It is the SHIPPING cost, so it now says so, on its own small line under the date (row stays 3 short lines). */
      row.classList.add('vvta-row0'); setText(row.querySelector('.vvbc-dr'), 'Shipping: calculated at checkout');
      var mob=window.matchMedia('(max-width:749px)').matches; /* phone: shorter sub-line so the row stays as tall as before */
      setText(row.querySelector('.vvbc-ds'), r.provisional ? items(r.qty)+' · estimated '+r.ready+(mob?'':', date set by our production team') : items(r.qty)+' · '+wd(r.days)+(mob?'':' after proof approval'));
      /* 2. Section label: "Estimated dispatch date" + a quiet toggle for the tiers */
      var lbl=null; [].forEach.call(document.querySelectorAll('.vvbc-flow .vvbc-label'),function(l){ if(!lbl && /(delivery|dispatch) date/i.test(l.textContent||'')) lbl=l; });
      if(!lbl) return;
      var bt=lbl.querySelector('b'); if(bt) setText(bt,'Estimated dispatch date');
      /* FIX 24 Oct (L1): plain tooltip, no fee and no date-picking (that was the old delivery-date picker's text) */
      var ti=lbl.querySelector('.vvbc-tip'); if(ti && ti.getAttribute('data-tip')!==TIP) ti.setAttribute('data-tip',TIP);
      var tog=lbl.querySelector('.vvta-tog'), pan=document.getElementById('vvta-pan');
      if(!tog){
        var left=document.createElement('span'); while(lbl.firstChild) left.appendChild(lbl.firstChild); lbl.appendChild(left); lbl.classList.add('vvta-lbl');
        tog=document.createElement('button'); tog.type='button'; tog.className='vvta-tog'; tog.setAttribute('aria-expanded','false'); tog.setAttribute('aria-controls','vvta-pan');
        tog.innerHTML='<span class="vvta-long">Turnaround &amp; delivery</span><span class="vvta-bq">Delivery times</span><i aria-hidden="true">▾</i>'; /* FIX2 24 Oct: was "Turnaround by quantity" / "By quantity" */ lbl.appendChild(tog);
        pan=document.createElement('div'); pan.id='vvta-pan'; pan.className='vvta-pan'; pan.hidden=true; lbl.parentNode.insertBefore(pan, lbl.nextSibling);
        tog.addEventListener('click',function(e){ e.stopPropagation(); var o=tog.getAttribute('aria-expanded')!=='true'; tog.setAttribute('aria-expanded',String(o)); pan.hidden=!o; });
      }
      var h='', fl=floorDays();
      cfg.tiers.forEach(function(t){
        var on=(t===r.tier)?' on':'';
        h+='<div class="vvta-row'+on+'"><span>'+range(t)+' items</span><span>'+(t.days===null?'we’ll confirm (about '+wd(Math.max(cfg.provisionalDays,fl))+')':wd(Math.max(t.days,fl)))+'</span></div>';
      });
      h+='<div class="vvta-dh">Delivery after dispatch<small>Courier estimate, business days</small></div><div class="vvta-dg">';
      DELIV.forEach(function(d){ h+='<div class="vvta-row"><span>'+d[0]+'</span><span>'+d[1]+'</span></div>'; });
      h+='</div>';
      if(fl>1) h+='<span class="vvta-sp">This product takes at least '+wd(fl)+' to make, so no quantity is ready sooner.</span>';
      h+='<span class="vvta-sp">'+cfg.smallPrint+'</span>';
      if(pan && pan.getAttribute('data-h')!==h){ pan.innerHTML=h; pan.setAttribute('data-h',h); }
    }
    function deadline(){
      var d=document.querySelector('.vvbc-deadline'); if(!d) return;
      d.classList.add('vvta-dl'); /* 24 Oct 17:47: one natural sentence, not two flex columns (owner's iPhone screenshot) */
      var r=forQty(currentQty(), floorDays());
      var left=(r.mins!==null && !r.provisional) ? ' · '+(Math.floor(r.mins/60)>0?Math.floor(r.mins/60)+'h ':'')+(r.mins%60)+'m left' : '';
      var txt='⏱ Approve your proof by <b>'+cut()+' on '+r.approveBy+'</b>';
      if(d.getAttribute('data-vvta')!==txt){ d.innerHTML=txt+'<span class="vvbc-dl-count"></span>'; d.setAttribute('data-vvta',txt); }
      setText(d.querySelector('.vvbc-dl-count'), left);
    }
    /* Ruby's launcher (agent.vividads.com.au/widget.js, fixed bottom-right, 58px). Two theme-side placements, Ruby unchanged:
       1. Shopify's preview bar (68px strip, only on ?preview_theme_id links) covers the launcher -> base lifts to 88px there.
       2. 24 Oct 17:47 (owner's iPhone screenshots): on phones the bubble sat on "Order with my own design" / "Design with AI"
          and the sticky buy bars. While a buy button is under the bubble, the bubble moves up just above it, then drops back
          to its corner once the button scrolls away. Never moved while the chat panel is open (it would sit on the panel). */
    var BUY='.vvbc-cta,.vv-cta,.vvbc-ctas a,.vvbc-ctas button,#vivid-sticky-buy,#vvm-bar .vvm-b,.calculate-button,.but-flex-layout button,.but-column button,.product-form__submit,button[name="add"]';
    function rubyPlace(){
      try{
        var b=null; [].forEach.call(document.querySelectorAll('body > button'),function(x){ if(!b && x.getAttribute('aria-label')==='Chat with us') b=x; });
        if(!b) return;
        var f=document.querySelector('body > iframe[src*="agent.vividads.com.au"]');
        var pbar=!!document.getElementById('PBarNextFrame'), base=pbar?88:20, want=base, open=!!(f && f.style.display==='block');
        if(!open && window.matchMedia('(max-width:749px)').matches){
          var vh=window.innerHeight, vw=document.documentElement.clientWidth, size=b.offsetHeight||58, L=vw-20-size-6, R=vw-14, rects=[];
          [].forEach.call(document.querySelectorAll(BUY),function(el){
            var r=el.getBoundingClientRect(); if(r.width<1||r.height<1||r.bottom<=0||r.top>=vh) return;
            if(getComputedStyle(el).visibility==='hidden') return;
            if(r.right>L && r.left<R) rects.push(r);
          });
          rects.sort(function(a,c){ return c.top-a.top; });
          for(var k=0;k<4;k++){ var moved=false;
            rects.forEach(function(r){ var top=vh-want-size-6, bot=vh-want+6; if(r.bottom>top && r.top<bot){ want=Math.ceil(vh-r.top+10); moved=true; } });
            if(!moved) break; }
          if(vh-want-size<70) want=base; /* no free spot on screen: stay in the corner */
        }
        if(b.style.bottom!==want+'px'){ if(!/bottom/.test(b.style.transition||'')) b.style.transition='transform .15s ease, bottom .2s ease'; b.style.bottom=want+'px'; }
        if(pbar && f && f.style.bottom!=='158px') f.style.bottom='158px';
      }catch(e){}
    }
    var rubyQ=false; function rubyTick(){ if(rubyQ) return; rubyQ=true; requestAnimationFrame(function(){ rubyQ=false; rubyPlace(); }); }
    window.addEventListener('scroll',rubyTick,{passive:true}); window.addEventListener('resize',rubyTick);
    document.addEventListener('click',function(){ setTimeout(rubyPlace,30); },true);
    setInterval(rubyPlace,800); /* widget and preview bar load late; buy box re-renders */
    /* keep the buy box in step with quantity changes even when the date-block teaser is not running */
    document.addEventListener('click',function(){ setTimeout(function(){ try{ table(); deadline(); }catch(e){} },350); },true);
    document.addEventListener('change',function(){ setTimeout(function(){ try{ table(); deadline(); }catch(e){} },350); },true);
    document.addEventListener('input',function(){ setTimeout(function(){ try{ table(); deadline(); }catch(e){} },600); },true);
    setTimeout(function(){ try{ table(); deadline(); }catch(e){} },2500);
    [300,800,1500].forEach(function(ms){ setTimeout(function(){ try{ table(); deadline(); }catch(e){} },ms); }); /* L2: rewrite the delivery + cut-off rows early */
    setInterval(function(){ try{ deadline(); }catch(e){} },60000);
    window.vvTurnaround = { forQty:forQty, tierFor:tierFor, currentQty:currentQty, table:table, deadline:deadline, wd:wd, cut:cut, fmt:fmt, get cfg(){ return cfg; } };
    /* live config from the console (cached 10 min in sessionStorage); static copy on any failure */
    try{
      var LIVE_CFG=false, k='vvTa1', c=null; try{ c=JSON.parse(sessionStorage.getItem(k)||'null'); }catch(e){}
      var use=function(j){ if(!j||!j.tiers||!j.tiers.length||!j.cutoff) return; var est=j.tiers.filter(function(t){return t.days===null;})[0], m=est&&/about (\d+)/.exec(est.label||'');
        cfg={ cutoffHour:j.cutoff.hour, provisionalDays:m?Number(m[1]):S.provisionalDays, tiers:j.tiers.map(function(t){return {min:t.min,max:t.max,days:t.days};}),
          holidays:S.holidays.concat((j.upcomingClosures||[]).map(function(x){return x.day;})), smallPrint:j.smallPrint||S.smallPrint }; };
      if(c && Date.now()-c.at<600000) use(c.j);
      /* LIVE_CFG off (24 Oct 17:47): the console API does not send CORS headers yet (its switch is OFF), so the call only
         printed a console error on every product page. Turn on once /api/turnaround allows https://www.vividads.com.au. */
      else if(LIVE_CFG) fetch('https://ai.vividads.com.au/api/turnaround?qty=1',{mode:'cors',credentials:'omit'}).then(function(r){return r.ok?r.json():null;}).then(function(j){ if(j){ use(j); try{ sessionStorage.setItem(k,JSON.stringify({at:Date.now(),j:j})); }catch(e){} } }).catch(function(){});
    }catch(e){}
  })();

  /* VIVID CRO: dispatch-date visibility + cut-off countdown (quantity tiers since 24 Oct 2026, see block above).
     The theme computes a production tier on every quote; this finally shows it. */
  (function(){
    var TIER_DAYS = { '3 hours':0, '24 hours':1, '48 hours':2, '72 hours':3, '96 hours':4, '7 days':7 };
    function sydneyNow(){ return new Date(new Date().toLocaleString('en-US',{timeZone:'Australia/Sydney'})); }
    function isBizDay(d){ var w=d.getDay(); return w!==0 && w!==6; }
    function addBizDays(d, n){ var x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); if(isBizDay(x)) n--; } return x; }
    function nextBizDay(d){ var x=new Date(d); do{ x.setDate(x.getDate()+1); }while(!isBizDay(x)); return x; }
    function fmt(d){ return d.toLocaleDateString('en-AU',{weekday:'long', day:'numeric', month:'long', timeZone:'Australia/Sydney'}); }
    function compute(tier){
      /* 24 Oct 2026: QUANTITY tiers (window.vvTurnaround). The product's own floor (VQ_TEASER_TIER, e.g. SEG 72h) is
         kept as a minimum; the old price bands no longer push the date. '3 hours' (same-day add-on) keeps the old path. */
      if(window.vvTurnaround && tier !== '3 hours'){
        var fl = (typeof VQ_TEASER_TIER !== 'undefined' && TIER_DAYS.hasOwnProperty(VQ_TEASER_TIER)) ? TIER_DAYS[VQ_TEASER_TIER] : 1;
        var r = window.vvTurnaround.forQty(window.vvTurnaround.currentQty(), fl > 1 ? fl : 0);
        window.__vvTaFloor = fl > 1 ? fl : 0;
        return { date: r.ready, mins: r.mins, r: r };
      }
      var days = TIER_DAYS.hasOwnProperty(tier) ? TIER_DAYS[tier] : 1;
      var now = sydneyNow();
      var beforeCutoff = isBizDay(now) && now.getHours() < 15;
      var start = beforeCutoff ? now : nextBizDay(now);
      var dispatch = days===0 ? (beforeCutoff ? now : nextBizDay(now)) : addBizDays(start, days);
      var mins = null;
      if(beforeCutoff){ var cut=new Date(now); cut.setHours(15,0,0,0); mins=Math.max(0, Math.round((cut-now)/60000)); }
      return { date: fmt(dispatch), mins: mins };
    }
    function render(tier){
      /* D2-1: dispatch visibility runs at ALL widths (desktop = 95% of revenue; same engine, text lines only) */
      var d = compute(tier);
      var html = '<svg class="vq-d-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h11v9H3zM14 8h4l3 3v3h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg><span class="vq-d-body">'+(d.r ? (d.r.provisional
        ? '<span class="vq-dispatch-date">Ready to dispatch: <b>we\u2019ll confirm</b> after you approve your proof (estimated '+d.r.ready+')</span><span class="vq-d-sub">For '+d.r.qty+' items our production team sets the date. Delivery time is added after dispatch.</span>'
        : '<span class="vq-dispatch-date">Approve your proof by '+window.vvTurnaround.cut()+' on '+d.r.approveBy+' \u2014 ready to dispatch <b>'+d.date+'</b></span><span class="vq-d-sub">'+d.r.qty+' item'+(d.r.qty===1?'':'s')+': '+window.vvTurnaround.wd(d.r.days)+'. Delivery time is added after dispatch.</span>')
        : '<span class="vq-dispatch-date">Approve your proof today, dispatches <b>'+d.date+'</b></span><span class="vq-d-sub">Production time confirmed with your quote</span>')+'</span>';
      if(d.mins!==null){ var h=Math.floor(d.mins/60), m=d.mins%60;
        html += '<span class="vq-dispatch-count">'+(h>0?(h+'h '):'')+m+'m left today</span>'; }
      /* quote card: under the TOTAL receipt */
      var totalReceipt = document.querySelector('#total-elementor .receipt:has(.total-heading)');
      if(totalReceipt){
        var stale = totalReceipt.querySelector('.vq-dispatch'); if(stale) stale.remove();
        var el = totalReceipt.parentNode.querySelector(':scope > .vq-dispatch') || document.createElement('div');
        el.className='vq-dispatch'; el.innerHTML=html;
        if(el.previousElementSibling !== totalReceipt) totalReceipt.parentNode.insertBefore(el, totalReceipt.nextSibling);
      }
      /* desktop: next to the visible total (the mobile receipt/trust containers are hidden >749px) */
      if(!window.matchMedia('(max-width:749px)').matches){
        var tp = document.getElementById('totalPrice');
        /* guard: if the price element lives inside the quote receipt, the
           receipt-adjacent card already serves - a second copy here would be
           deleted+recreated every tick and make the buttons below jump */
        if(tp && tp.offsetParent !== null && !(totalReceipt && (totalReceipt.contains(tp) || (tp.closest('div') && totalReceipt.contains(tp.closest('div')))))){
          var host = tp.closest('div') || tp.parentElement;
          var el3 = host.parentElement.querySelector(':scope > .vq-dispatch') || host.querySelector(':scope > .vq-dispatch');
          if(!el3){ el3 = document.createElement('div'); el3.className = 'vq-dispatch'; host.appendChild(el3); }
          el3.innerHTML = html;
        }
      }
      /* artwork step: inside the trust card, after the total row */
      var trust = document.querySelector('.vq-trust');
      if(trust){
        var el2 = trust.querySelector('.vq-dispatch') || document.createElement('div');
        el2.className='vq-dispatch'; el2.innerHTML=html;
        var tt = trust.querySelector('.vq-trust-total');
        if(tt && !trust.querySelector('.vq-dispatch')) tt.parentNode.insertBefore(el2, tt.nextSibling); else trust.appendChild(el2);
      }
    }
    /* search→quote funnel events (pairs with vq_search_* events in search-dropdown.liquid) */
    function vqTrack(ev, data){
      try{
        window.dataLayer = window.dataLayer || [];
        var o = { event: ev }; for(var k in (data||{})) o[k] = data[k];
        dataLayer.push(o);
        if(window.gtag) gtag('event', ev, data || {});
      }catch(e){}
    }
    document.addEventListener('change', function h(e){
      if(e.target && e.target.tagName === 'SELECT'){
        vqTrack('vq_configurator_started');
        document.removeEventListener('change', h, true);
      }
    }, true);
    var renderBase = render;
    render = function(tier){
      if(!window.__vqQuoteTracked){ window.__vqQuoteTracked = 1; vqTrack('vq_quote_generated'); }
      return renderBase(tier);
    };
    /* ===== LAUNCH BLOCKER FIX: parse-time sticky bar (product.js is optimizer-deferred = type lazyJs,
       so the sticky button had NO handler until after the first interaction — the user's first tap on
       "See total"/"Buy Now" did nothing). This boot runs at parse, owns the bar, and waits for the
       legacy jQuery wiring (sentinel window.__vqProductJs) before delegating clicks to legacy targets. */
    function vqToast(msg){
      var t = document.querySelector('.vq-toast');
      if(!t){ t = document.createElement('div'); t.className = 'vq-toast'; document.body.appendChild(t); }
      t.textContent = msg; t.classList.add('show');
      clearTimeout(t.__h); t.__h = setTimeout(function(){ t.classList.remove('show'); }, 3200);
    }
    /* ===== REPAIR PASS 2: artwork state controller (single source of UI truth) =====
       Legacy semantics: design_exist (upload myself: 'later' sub-card #upload--instructions /
       'now' sub-card #upload_now_container, signalled by .active-container) · design_assist · AI card. */
    function vqArtEls(){
      return {
        later: document.getElementById('upload--instructions'),
        now: document.getElementById('upload_now_container'),
        assist: document.querySelector('.vq-assist-card:not(.vq-ai-card)'),
        ai: document.querySelector('.vq-ai-card')
      };
    }
    function vqFileUploaded(){
      var t = document.querySelectorAll('.uploadkit-thumbnails');
      for(var i = 0; i < t.length; i++){ if(t[i].children.length > 0) return true; }
      var fi = document.querySelectorAll('#upload_section input[type="file"], .option-content-wrapper input[type="file"]');
      for(var j = 0; j < fi.length; j++){ if(fi[j].files && fi[j].files.length) return true; }
      return false;
    }
    /* P1 fix: buy buttons can be hidden by ANCESTOR .hide/.hidden (e.g. #total-elementor), not just
       their own class — clear the whole chain, but only ever called in VALID order states. */
    function vqForceVisible(el){
      if(!el) return false;
      var p = el, n = 0;
      while(p && p !== document.body && n < 12){
        if(p.classList && (p.classList.contains('hide') || p.classList.contains('hidden'))){
          p.classList.remove('hide'); p.classList.remove('hidden');
        }
        if(p.style && p.style.display === 'none') p.style.display = '';
        p = p.parentElement; n++;
      }
      return el.offsetParent !== null;
    }
    window.__vqArtGet = function(){
      var e = vqArtEls();
      var sel = window.__vqArtSel;
      if(!sel){
        if(document.body.classList.contains('design_assist')) sel = 'assist';
        else if(e.now && e.now.classList.contains('active-container')) sel = 'now';
        else if(vqFileUploaded()) sel = 'now';
        else sel = 'later';
      }
      return { sel: sel, file: vqFileUploaded() };
    };
    function vqArtApply(){
      var e = vqArtEls();
      var st = window.__vqArtGet();
      [['later', e.later], ['now', e.now]].forEach(function(pair){
        if(!pair[1]) return;
        pair[1].classList.toggle('vq-on', st.sel === pair[0]);
        pair[1].classList.toggle('vq-off', st.sel !== pair[0]);
      });
      if(e.assist){ e.assist.classList.toggle('sel', st.sel === 'assist'); e.assist.classList.toggle('vq-off', st.sel !== 'assist'); }
      if(e.ai){ e.ai.classList.toggle('sel', st.sel === 'ai'); e.ai.classList.toggle('vq-off', st.sel !== 'ai'); }
      /* uploaded-file confirmation row inside the now card */
      if(e.now){
        var ok = e.now.querySelector('.vq-file-ok');
        if(st.file && st.sel === 'now'){
          if(!ok){ ok = document.createElement('div'); ok.className = 'vq-file-ok'; ok.textContent = '\u2713 File attached \u2014 ready to order'; e.now.appendChild(ok); }
        } else if(ok){ ok.remove(); }
      }
      /* explicit "selected" confirmation at the top of the expanded card */
      var names = { later: 'Upload artwork later', now: 'Upload artwork now', assist: 'Design assistance', ai: 'Create designs with AI' };
      var selEl = (st.sel === 'later') ? e.later : (st.sel === 'now') ? e.now : (st.sel === 'assist') ? e.assist : e.ai;
      document.querySelectorAll('.vq-sel-note').forEach(function(n){ if(!selEl || !selEl.contains(n)) n.remove(); });
      if(selEl && !selEl.querySelector('.vq-sel-note')){
        var note = document.createElement('div'); note.className = 'vq-sel-note';
        note.textContent = 'Selected';
        note.setAttribute('aria-label', names[st.sel] + ' selected');
        selEl.insertBefore(note, selEl.firstChild);
      }
      /* sticky confidence line: artwork state + dispatch date above Buy Now */
      var bar = document.getElementById('vivid-sticky-atc');
      if(bar && document.body.classList.contains('vq-step2')){
        var dl = bar.querySelector('.vivid-sticky-disp');
        if(!dl){ dl = document.createElement('div'); dl.className = 'vivid-sticky-disp';
          var lblEl = bar.querySelector('.vivid-sticky-atc__label'); (lblEl && lblEl.parentNode ? lblEl.parentNode : bar).appendChild(dl); }
        var ready = (st.sel === 'later') || (st.sel === 'now' && st.file) || st.sel === 'assist' || st.sel === 'ai';
        var dd = (typeof compute === 'function') ? compute(VQ_TEASER_TIER) : null;
        dl.textContent = (ready ? '\u2713 Artwork ready \u00b7 ' : '') + (dd ? (dd.r && dd.r.provisional ? 'Ready to dispatch: we\u2019ll confirm (est. ' + dd.date + ')' : 'Ready to dispatch ' + dd.date) : '');
      }
      /* assist price resync (card was built before the deferred legacy filled the charge) */
      var pc = document.querySelector('.vq-assist-card:not(.vq-ai-card) .vq-price');
      var d = document.getElementById('design_charges_dpo');
      if(pc && d){ var v = parseFloat((d.textContent||'').replace(/[^0-9.]/g, '')) || 0; if(v > 0) pc.textContent = '+$' + d.textContent.trim(); }
    }
    window.__vqSetArt = function(key){
      window.__vqArtSel = key;
      vqArtApply();
    };
    function vqWireArtCards(){
      var e = vqArtEls();
      [['later', e.later], ['now', e.now]].forEach(function(pair){
        var key = pair[0], el = pair[1];
        if(!el || el.__vqWired) return; el.__vqWired = 1;
        el.addEventListener('click', function(){
          window.__vqSetArt(key);
          /* sync the legacy machine once its jQuery handlers exist */
          var t0 = Date.now();
          var iv = setInterval(function(){
            if(window.__vqProductJs && window.jQuery){
              clearInterval(iv);
              var a = el.querySelector('a'); if(a && !el.classList.contains('active-container')) a.click();
            } else if(Date.now() - t0 > 12000){ clearInterval(iv); }
          }, 200);
        }, true);
      });
    }
    setInterval(function(){
      if(!document.body.classList.contains('vq-step2')) return;
      vqWireArtCards(); vqArtApply();
    }, 800);
    function vqStickyBoot(){
      var bar = document.getElementById('vivid-sticky-atc');
      if(!bar || bar.classList.contains('is-ready')) return;
      var out = document.getElementById('vivid-sticky-price');
      var b = document.getElementById('vivid-sticky-buy');
      if(!out || !b) return;
      var priceEl = document.getElementById('totalPrice');
      function sync(){ if(!window.__vqCalculated) return; var t = priceEl ? (priceEl.textContent||'').trim() : ''; if(t) out.textContent = t; }
      window.vividStickyCalculated = function(){
        window.__vqCalculated = true;
        document.body.classList.add('vq-calc-done');
        var lbl = bar.querySelector('.vivid-sticky-atc__label'); if(lbl) lbl.textContent = document.body.classList.contains('vq-step2') ? 'Ready to order' : 'Total estimate';
        b.textContent = document.body.classList.contains('vq-step2') ? 'Buy Now' : 'Continue';
        b.removeAttribute('data-vq-label'); b.classList.remove('vq-loading'); /* the calc relabel wins over any pending loading restore */
        sync();
      };
      if(priceEl){ try{ new MutationObserver(sync).observe(priceEl, { childList:true, subtree:true, characterData:true }); }catch(e){} }
      bar.classList.add('is-ready'); bar.setAttribute('aria-hidden','false'); document.body.classList.add('vivid-has-sticky');
      function setLoading(label){
        b.classList.add('vq-loading');
        if(!b.getAttribute('data-vq-label')) b.setAttribute('data-vq-label', b.textContent);
        b.textContent = label;
      }
      function clearLoading(){
        b.classList.remove('vq-loading');
        var l = b.getAttribute('data-vq-label');
        if(l){ b.removeAttribute('data-vq-label'); if(!window.__vqCalculated) b.textContent = l; else b.textContent = document.body.classList.contains('vq-step2') ? 'Buy Now' : 'Continue'; }
      }
      function whenLegacyReady(fn){
        if(window.__vqProductJs && window.jQuery){ fn(true); return; }
        var t0 = Date.now();
        var iv = setInterval(function(){
          if(window.__vqProductJs && window.jQuery){ clearInterval(iv); fn(true); }
          else if(Date.now() - t0 > 12000){ clearInterval(iv); fn(false); }
        }, 150);
      }
      function watchCartOpen(){
        var iv = setInterval(function(){
          var open = document.querySelector('#slidecarthq .slidecarthq');
          if(open && open.offsetParent !== null){ clearInterval(iv); clearTimeout(to); clearLoading(); }
        }, 400);
        var to = setTimeout(function(){ clearInterval(iv); clearLoading(); }, 12000);
      }
      b.addEventListener('click', function(){
        if(b.classList.contains('vq-loading')) return; /* no double-tap */
        if(document.body.classList.contains('vq-step2')){
          var artSt = window.__vqArtGet ? window.__vqArtGet() : null;
          if(artSt && artSt.sel === 'now' && !artSt.file){
            vqToast('Attach your artwork file, or choose \u201cUpload artwork later\u201d');
            var nc = document.getElementById('upload_now_container');
            if(nc){ var yn = nc.getBoundingClientRect().top + window.pageYOffset - 100; window.scrollTo({ top: yn < 0 ? 0 : yn, behavior: 'smooth' }); }
            return;
          }
          setLoading('Adding…');
          whenLegacyReady(function(ok){
            if(!ok){ clearLoading(); vqToast('Still loading — please try again'); return; }
            var cands = ['#skip_upload', '#continue_cart', '.but-flex-layout .quote_btn .confirm_order', '#AddToCart:not(.hide)', 'button[name="add"]'];
            for(var c = 0; c < cands.length; c++){
              var el = document.querySelector(cands[c]);
              if(el && el.offsetParent !== null && !el.disabled){ el.click(); watchCartOpen(); return; }
            }
            /* valid order state but every candidate hidden (legacy machine desync) → unhide the chain and retry */
            var stNow = window.__vqArtGet ? window.__vqArtGet() : null;
            if(stNow && (stNow.file || stNow.sel === 'later' || stNow.sel === 'assist')){
              var pref = stNow.file ? ['#continue_cart', '#skip_upload'] : ['#skip_upload', '#continue_cart'];
              for(var f = 0; f < pref.length; f++){
                var fel = document.querySelector(pref[f]);
                if(fel && !fel.disabled && vqForceVisible(fel)){ fel.click(); watchCartOpen(); return; }
              }
            }
            clearLoading();
            vqToast('Choose an artwork option above to continue');
            var art = document.querySelector('.requiredesignstep, .vq-artcard, #upload_section');
            if(art){ var ya = art.getBoundingClientRect().top + window.pageYOffset - 90; window.scrollTo({ top: ya < 0 ? 0 : ya, behavior: 'smooth' }); }
          });
          return;
        }
        if(window.__vqCalculated){
          var cont = document.querySelector('.but-flex-layout .quote_btn .confirm_order');
          if(cont && cont.offsetParent !== null){ cont.click(); return; }
        } else {
          /* See total: highlight missing fields, otherwise run the calculation (waiting for legacy wiring) */
          var fsels = [].slice.call(document.querySelectorAll('.product-variants select, #quote-tab select')).filter(function(s){ return s.offsetParent !== null; });
          var missing = null;
          for(var j = 0; j < fsels.length; j++){
            var s = fsels[j], o = s.options[s.selectedIndex];
            if(!s.value || /^(select|choose|pick|--)/i.test(((o && o.text) || '').trim())){ missing = s; break; }
          }
          if(missing){
            missing.classList.add('vq-field-missing');
            (function(m){ setTimeout(function(){ m.classList.remove('vq-field-missing'); }, 2600); })(missing);
            vqToast('Choose an option to see your total');
            var ym = missing.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: ym < 0 ? 0 : ym, behavior: 'smooth' });
            return;
          }
          setLoading('Calculating…');
          whenLegacyReady(function(ok){
            if(!ok){ clearLoading(); vqToast('Still loading — please try again'); return; }
            var calc = document.querySelector('.calculate-button');
            if(calc && calc.offsetParent !== null){
              calc.click();
              var t0 = Date.now();
              var iv = setInterval(function(){
                if(window.__vqCalculated || Date.now() - t0 > 10000){ clearInterval(iv); clearLoading(); }
              }, 300);
              return;
            }
            clearLoading();
          });
          return;
        }
        var sels2 = window.__vqCalculated ? ['#AddToCart:not(.hide)', '.calculate-button', 'button[name="add"]', '#totalPrice'] : ['.product-variants', '#PDPQty', '.requiredesignstep', '.calculate-button'];
        for(var i = 0; i < sels2.length; i++){ var t = document.querySelector(sels2[i]); if(t && t.offsetParent !== null){ var y = t.getBoundingClientRect().top + window.pageYOffset - 70; window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); return; } }
      }, true);
    }
    vqStickyBoot(); setTimeout(vqStickyBoot, 400); setTimeout(vqStickyBoot, 1500);
    /* D2-6 PROTOTYPE (awaiting approval): desktop inclusion ticks above the configurator */
    function vqReceiveDesktop(){
      if(window.matchMedia('(max-width:749px)').matches) return;
      var dsel = document.querySelector('.product-variants select');
      var dtarget = null;
      var pvs = document.querySelectorAll('.product-variants');
      for(var i = 0; i < pvs.length; i++){ if(pvs[i].offsetParent !== null){ dtarget = pvs[i]; break; } }
      if(!dsel || !dtarget) return;
      var dopt = dsel.options[dsel.selectedIndex]; var dtxt = dopt ? (dopt.text || '') : '';
      var dold = document.querySelector('.vq-receive-desktop');
      if(dtxt.indexOf('+') >= 0){
        var dparts = dtxt.split('+').map(function(x){ return x.trim(); }).filter(Boolean);
        var dhtml = '<span class="vq-receive-t">What you\u2019ll receive</span>' + dparts.map(function(x){ return '<span><i class="vq-tick">\u2713</i>' + x + '</span>'; }).join('') + '<span class="vq-chip-au"><i class="vq-tick">\u2713</i>Printed in Australia</span>';
        if(dold){ dold.innerHTML = dhtml; }
        else { var del = document.createElement('div'); del.className = 'vq-receive-desktop'; del.innerHTML = dhtml; dtarget.parentNode.insertBefore(del, dtarget); }
      } else if(dold){ dold.remove(); }
    }
    setTimeout(vqReceiveDesktop, 600); setTimeout(vqReceiveDesktop, 2500);
    document.addEventListener('change', function(ev){ if(ev.target && ev.target.matches && ev.target.matches('.product-variants select')) setTimeout(vqReceiveDesktop, 150); }, true);
    window.vividDispatchUpdate = render;
    /* Phase 1: dispatch teaser on the fold, pre-calculate. Same engine, same cutoff math.
       "as soon as" wording — exact date for the order still comes from the real tier at quote time. */
    var VQ_TEASER_TIER = window.__vqTeaserTier || '24 hours';
    function teaser(){
      var mob = window.matchMedia('(max-width:749px)').matches;
      var el = document.querySelector('.vq-dispatch-teaser');
      if(document.body.classList.contains('vq-calc-done')){ if(el) el.style.display='none'; return; }
      var anchor = mob ? document.querySelector('.vivid-fold__delivery') : document.querySelector('.calculate-button');
      if(!anchor) return;
      if(!el){
        el = document.createElement('div'); el.className='vq-dispatch-teaser';
        if(mob){ anchor.parentNode.insertBefore(el, anchor.nextSibling); }
        else { anchor.parentNode.insertBefore(el, anchor); }
      }
      /* 24-Aug bug #113 (Imran): the teaser tier was hardcoded per product, so 100 flags
         still read "24 hour production". Reuse the quote engine's price bands from
         product.js (the rule the store has always quoted with): <$1000 24h, ≤$2000 48h,
         ≤$3000 72h, ≤$5000 96h, else 7 days. The live total feeds it — native buy-cards
         (.vvbc-tp) or the calculated quote (#tprice). The hardcoded tier stays as a FLOOR
         (SEG lightbox never drops below 72h); price can only push the tier up, never down. */
      var vqTier = VQ_TEASER_TIER;
      if(window.vvTurnaround){ try{ window.vvTurnaround.table(); window.vvTurnaround.deadline(); }catch(e){} }
      if(!window.vvTurnaround) try{
        var vqTotEl = document.querySelector('.vvbc-tp') || document.getElementById('tprice');
        var vqTot = vqTotEl ? parseFloat((vqTotEl.textContent||'').replace(/[^0-9.]/g,'')) : NaN;
        if(isFinite(vqTot) && vqTot > 0){
          var vqByPrice = vqTot < 1000 ? '24 hours' : vqTot <= 2000 ? '48 hours' : vqTot <= 3000 ? '72 hours' : vqTot <= 5000 ? '96 hours' : '7 days';
          var vqRank = {'24 hours':1,'48 hours':2,'72 hours':3,'96 hours':4,'7 days':5};
          if((vqRank[vqByPrice]||1) > (vqRank[vqTier]||1)) vqTier = vqByPrice;
        }
      }catch(e){}
      var d = compute(vqTier);
      var prod = ({'24 hours':'24 hour production','48 hours':'2 day production','72 hours':'3 day production','96 hours':'4 day production','7 days':'7 day production'})[vqTier] || '24 hour production';
      var html = '<span class="vqt-date">Approve your proof today</span>' +
                 '<span class="vqt-disp">Dispatches <b>'+d.date+'</b></span>';
      if(d.mins!==null){ var h=Math.floor(d.mins/60), m=d.mins%60;
        html += '<span class="vqt-count">Approve within '+(h>0?(h+'h '):'')+m+'m</span>'; }
      if(d.r){
        html = d.r.provisional
          ? '<span class="vqt-date">For '+d.r.qty+' items we confirm the date after proof approval</span><span class="vqt-disp">Estimated ready to dispatch <b>'+d.date+'</b></span>'
          : '<span class="vqt-date">Approve your proof by '+window.vvTurnaround.cut()+', '+d.r.approveBy+'</span><span class="vqt-disp">Ready to dispatch <b>'+d.date+'</b></span>';
        if(d.mins!==null && !d.r.provisional){ var h2=Math.floor(d.mins/60), m2=d.mins%60; html += '<span class="vqt-count">'+(h2>0?(h2+'h '):'')+m2+'m left today</span>'; }
        el.innerHTML = html + '<span class="vqt-sub">'+d.r.qty+' item'+(d.r.qty===1?'':'s')+': '+(d.r.provisional?'about ':'')+window.vvTurnaround.wd(d.r.days)+' &middot; delivery time added after dispatch</span>';
      } else
      el.innerHTML = html + '<span class="vqt-sub">'+prod+' &middot; exact date confirmed with your quote</span>';
      el.style.display='block';
    }
    setTimeout(teaser, 200); setTimeout(teaser, 1500); setTimeout(teaser, 4000);
    /* keep countdowns fresh + hide teaser once the full dispatch panel takes over */
    setInterval(function(){ if(window.__vqDispatchTier && document.body.classList.contains('vq-calc-done')) render(window.__vqDispatchTier); teaser(); }, 60000);
    document.addEventListener('click', function(){ setTimeout(teaser, 800); }, true);
    /* #113: exact-quantity typing changes the total without a click — refresh the tier then too */
    document.addEventListener('input', function(){ setTimeout(teaser, 900); }, true);
  })();
  /* VIVID CRO: "Save quote" — re-expose the hidden email-quote machinery with approval framing */
  (function(){
    function inject(){
      if(!window.matchMedia('(max-width:749px)').matches) return;
      if(document.querySelector('.vq-savequote')) return;
      var trigger = document.getElementById('getQuote');
      var anchor = document.querySelector('.but-flex-layout');
      if(!trigger || !anchor) return;
      var el=document.createElement('div'); el.className='vq-savequote';
      el.innerHTML='<button type="button" class="vq-savequote-btn">Save quote — email it to yourself or your manager</button><span class="vq-savequote-note">They can approve &amp; pay straight from the email.</span>';
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
      el.querySelector('button').addEventListener('click', function(){ var t=document.getElementById('getQuote'); if(t) t.click(); });
    }
    setTimeout(inject, 1500); setTimeout(inject, 4000);
  })();
  /* VIVID CRO: Read-more clamp for long product descriptions — ALL viewports (prototype behaviour:
     description shown expanded, clamped with a Read more toggle). Was mobile-only. */
  (function(){
    function vqClampInit(){
      var els=document.querySelectorAll('.product-description');
      for(var i=0;i<els.length;i++){(function(el){
        if(el.getAttribute('data-vq-clamp'))return; el.setAttribute('data-vq-clamp','1');
        if(el.scrollHeight>560){
          el.classList.add('vq-clamped');
          var b=document.createElement('button'); b.type='button'; b.className='vq-readmore'; b.textContent='Read more';
          b.addEventListener('click',function(){ var c=el.classList.toggle('vq-clamped'); b.textContent=c?'Read more':'Read less'; });
          if(el.parentNode) el.parentNode.insertBefore(b, el.nextSibling);
        }
      })(els[i]);}
    }
    setTimeout(vqClampInit,1500); setTimeout(vqClampInit,4000);
  })();

/* 27 Sep 2026 (Report 82): mobile sticky bar mirrors the buy panel's own "Total price" (read, never
   computed). Before this, #vivid-sticky-price kept the first variant's figure after a size/qty change. */
(function(){
  var DPO=['fence-mesh-banners','graphics-only-curved-stretch-fabric-walls','life-size-cutouts','real-estate-directional-signs','real-estate-pointer-signs','replacement-graphics-led-pop-up-counter','replacement-graphics-only-exhibition-tv-stand','replacement-graphics-only-pop-up-counters','replacement-graphics-only-pump-up-counters'];
  function dpoPriced(){ var h=''; try{ var d=document.getElementById('vvbc-data'); if(d) h=JSON.parse(d.textContent).handle||''; }catch(e){}
    if(!h){ var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(m) h=decodeURIComponent(m[1]); }
    return DPO.indexOf(h)>-1; }
  function sync(){
    var t=[].find.call(document.querySelectorAll('.vvbc-tp'),function(e){return e.offsetParent!==null;});
    var p=document.getElementById('vivid-sticky-price');
    if(t && p && /\$\s?\d/.test(t.textContent)){ var v=t.textContent.trim(); if(p.textContent!==v) p.textContent=v; }
  }
  function arm(n){
    var host=document.querySelector('.vvbc');
    if(!host){ if((n||0)<40) setTimeout(function(){arm((n||0)+1);},500); return; }
    if(dpoPriced()) return; // Class A/DPO (Report 83 option b): keep live sticky behaviour
    sync();
    try{ new MutationObserver(sync).observe(host,{childList:true,subtree:true,characterData:true}); }catch(e){}
  }
  arm(0);
})();
